// Koravela — custom scripts. Vanilla JS, no dependencies.

function mtInitReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (el) { io.observe(el); });
}

function mtInitCountUp() {
  var els = document.querySelectorAll('.mt-countup');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      io.unobserve(el);
      var target = parseFloat(el.getAttribute('data-target') || el.textContent) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      var decimals = el.getAttribute('data-decimals') ? parseInt(el.getAttribute('data-decimals'), 10) : 0;
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (start === null) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var val = target * eased;
        el.textContent = val.toFixed(decimals) + suffix;
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target.toFixed(decimals) + suffix;
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { io.observe(el); });
}

function mtInitTilt() {
  var cards = document.querySelectorAll('.mt-tilt');
  if (!cards.length || window.matchMedia('(pointer: coarse)').matches) return;
  cards.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = 'perspective(800px) rotateY(' + (x * 6) + 'deg) rotateX(' + (y * -6) + 'deg) translateY(-4px)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  });
}

function mtInitProductGallery() {
  var galleries = document.querySelectorAll('[data-mt-gallery]');
  galleries.forEach(function (gallery) {
    var main = gallery.querySelector('[data-mt-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-mt-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full') || thumb.querySelector('img').src;
        var mainImg = main.querySelector('img');
        if (mainImg) {
          mainImg.style.opacity = '0';
          setTimeout(function () {
            mainImg.src = src;
            mainImg.style.opacity = '1';
          }, 180);
        }
        thumbs.forEach(function (t) { t.classList.remove('mt-thumb-active'); });
        thumb.classList.add('mt-thumb-active');
      });
    });
  });
}

function mtInitVariantPicker() {
  var forms = document.querySelectorAll('[data-mt-product-form]');
  forms.forEach(function (formWrap) {
    var dataEl = formWrap.querySelector('[data-mt-variants-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = formWrap.querySelectorAll('[data-mt-option-select]');
    var idInput = formWrap.querySelector('[data-mt-variant-id]');
    var priceEl = formWrap.querySelector('[data-mt-price]');
    var compareEl = formWrap.querySelector('[data-mt-compare-price]');
    var submitBtn = formWrap.querySelector('[data-mt-submit]');

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function findVariant() {
      var selected = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function update() {
      var variant = findVariant();
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        if (variant.available) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.getAttribute('data-label-available') || 'Add to cart';
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = submitBtn.getAttribute('data-label-sold-out') || 'Sold out';
        }
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  });
}

function mtInitMarqueeSpeed() {
  document.querySelectorAll('[data-mt-marquee-speed]').forEach(function (track) {
    var speed = parseFloat(track.getAttribute('data-mt-marquee-speed')) || 30;
    track.style.animationDuration = speed + 's';
  });
}

document.addEventListener('DOMContentLoaded', function () {
  mtInitReveal();
  mtInitCountUp();
  mtInitTilt();
  mtInitProductGallery();
  mtInitVariantPicker();
  mtInitMarqueeSpeed();
});
